export const toLiveEventCardModel = event => Object.assign({}, event, {
  type: 'LIVE_EVENT',
  progress: null
});